export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2dfba73eefc3d4f2067caacc376b7f890f0387c9&name=fetchTypeahead!'